import { useCallback } from 'react';

export const useInstallTracking = () => {
  const track = useCallback((event: string, data?: Record<string, any>) => {
    console.log(`[PWA Install] ${event}`, data || '');
    // Future: send to analytics
  }, []);

  return { track };
};
